/**
 * @file usePagination.js
 * @description 通用分页组件逻辑
 * @module shared/composables/usePagination
 */

import { computed, ref, watch } from 'vue'

const PAGE_SIZE_OPTIONS = [6, 10, 12, 20, 30, 50]

/**
 * @param {{
 *   totalPages: number,
 *   currentPage: number,
 *   pageSize: number,
 * }} props
 * @param {(event: 'change-page' | 'change-page-size', value: number) => void} emit
 */
export function usePagination(props, emit) {
  const inputPage = ref(props.currentPage)
  const localPageSize = ref(props.pageSize)

  watch(
    () => props.pageSize,
    (newVal) => {
      localPageSize.value = newVal
    }
  )

  watch(
    () => props.currentPage,
    (newVal) => {
      inputPage.value = newVal
    }
  )

  const pages = computed(() => {
    const range = 2
    const result = []

    if (props.totalPages <= 7) {
      for (let i = 1; i <= props.totalPages; i++) {
        result.push(i)
      }
      return result
    }

    if (props.currentPage > range + 2) {
      result.push(1, '...')
    }

    for (
      let i = Math.max(1, props.currentPage - range);
      i <= Math.min(props.totalPages, props.currentPage + range);
      i++
    ) {
      result.push(i)
    }

    if (props.currentPage < props.totalPages - range - 1) {
      result.push('...', props.totalPages)
    }

    return result
  })

  function changePage(page) {
    const pageNum = Number(page)
    const currentPageNum = Number(props.currentPage)
    const totalPagesNum = Number(props.totalPages)

    if (
      page !== '...' &&
      pageNum !== currentPageNum &&
      pageNum > 0 &&
      pageNum <= totalPagesNum
    ) {
      emit('change-page', pageNum)
    }
  }

  function jumpToPage() {
    if (
      inputPage.value &&
      inputPage.value > 0 &&
      inputPage.value <= props.totalPages
    ) {
      emit('change-page', inputPage.value)
    } else {
      alert(`请输入有效页码（1 - ${props.totalPages}）`)
    }
  }

  function handlePageSizeChange() {
    emit('change-page-size', localPageSize.value)
  }

  return {
    inputPage,
    localPageSize,
    pageSizeOptions: PAGE_SIZE_OPTIONS,
    pages,
    changePage,
    jumpToPage,
    handlePageSizeChange,
  }
}
